import React from 'react';

import CubicCapacity from './CubicCapacity';
import BoatDimensions from './BoatDimensions';
import { PONTOON } from 'constants/boatApplication';

export default function CubicCapacityScene(props) {
  if (props.boat.boatType === PONTOON) return <BoatDimensions {...props} />;
  return <CubicCapacity {...props} />;
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/New/CubicCapacityScene/index.jsx